import { combineReducers, type Reducer, type ReducersMapObject } from "redux";
import { reducer as login } from "./containers/Login/slice";

export default function createReducer(
  injectedReducers: ReducersMapObject = {},
): Reducer {
  return combineReducers({
    login,
    ...injectedReducers,
  });
}
